// Home <-> Catalog only, deliberately: a small, explicit enhancement over Dawn's normal
// full-page navigation for exactly one round trip (the site's two "hub" pages), not a
// site-wide client router. Every other link (PDP, cart, footer legal pages, external sites)
// keeps behaving like a plain <a> — real navigation, no interception. See the
// cowalkies-design-system skill for the full rationale and the animations.js listener-cleanup
// this depends on.
(function () {
  var main = document.getElementById('MainContent');
  if (!main) return;

  var homeUrl = normalizePath(main.getAttribute('data-home-url'));
  var catalogUrl = normalizePath(main.getAttribute('data-catalog-url'));
  if (!homeUrl || !catalogUrl) return;

  var TRANSITION_MS = 400;
  var isTransitioning = false;

  function normalizePath(path) {
    if (!path) return null;
    var trimmed = path.replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
  }

  function currentPath() {
    return normalizePath(window.location.pathname);
  }

  function isEnhancedTransition(fromPath, toPath) {
    return (fromPath === homeUrl && toPath === catalogUrl) || (fromPath === catalogUrl && toPath === homeUrl);
  }

  document.addEventListener('click', function (e) {
    if (isTransitioning) return;
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    if (link.origin !== window.location.origin) return;

    var toPath = normalizePath(link.pathname);
    var fromPath = currentPath();
    if (!isEnhancedTransition(fromPath, toPath)) return;
    if (toPath === fromPath && link.search === window.location.search) return;

    e.preventDefault();
    // Following a link normally unloads the page, which closes the header's dropdown menu for
    // free — preventDefault()ing it here means nothing else would ever think to fold the menu
    // back, since the click that triggered this originated *inside* the header (header.js's own
    // outside-click listener only closes it for clicks landing outside the header).
    if (window.CowalkiesHeader && window.CowalkiesHeader.closeMenu) window.CowalkiesHeader.closeMenu();
    navigateTo(link.href, {});
  });

  // A back/forward step that lands on one of the two enhanced pages replays the same swap this
  // module does on click; a step that lands anywhere else was never intercepted in the first
  // place, so the browser's own real navigation already handled it correctly.
  window.addEventListener('popstate', function () {
    if (isTransitioning) return;
    var toPath = currentPath();
    if (toPath !== homeUrl && toPath !== catalogUrl) return;
    if (window.CowalkiesHeader && window.CowalkiesHeader.closeMenu) window.CowalkiesHeader.closeMenu();
    navigateTo(window.location.href, { isPopState: true });
  });

  function navigateTo(url, opts) {
    isTransitioning = true;
    main.classList.add('is-page-transitioning');

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('page transition fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.getElementById('MainContent');
        if (!newMain) throw new Error('missing #MainContent in response');

        // Let the dim-out actually finish before swapping the DOM underneath it — matches this
        // rule's own 0.4s duration (see #MainContent.is-page-transitioning in layout/theme.liquid)
        // so the motion reads as one continuous fade through, not a cut mid-transition.
        window.setTimeout(function () {
          completeSwap(newMain, doc, url, opts);
        }, TRANSITION_MS);
      })
      .catch(function () {
        // Real navigation is the correct fallback for anything unexpected here — the shopper
        // still gets to the page they clicked toward, just without the enhancement.
        window.location.href = url;
      });
  }

  function completeSwap(newMain, doc, url, opts) {
    // Cancel every scroll/resize listener the outgoing page's own scripts registered *before*
    // the incoming page's scripts run and register their own — see the shared registry in
    // assets/animations.js. Without this, repeated Home<->Catalog trips would stack up duplicate
    // window-level listeners all fighting over the same elements.
    if (window.CowalkiesAnimations) window.CowalkiesAnimations.resetListeners();

    // A <script> element inserted via innerHTML never executes (a browser rule, not a bug) —
    // pull the src values out first, drop the now-inert tags, and re-create real <script>
    // elements for each *after* the swap so the incoming page's own behavior (buy buttons,
    // carousel, category filter/sort) actually wires up against the fresh DOM. Every one of
    // these scripts already assumes a single run over whatever's currently in the document, so
    // re-executing them here is exactly what a real navigation would have done anyway — already-
    // loaded URLs come back out of the browser's own HTTP cache, not a second real fetch.
    var scriptSrcs = Array.prototype.map.call(newMain.querySelectorAll('script[src]'), function (s) {
      return s.getAttribute('src');
    });
    newMain.querySelectorAll('script[src]').forEach(function (s) {
      s.remove();
    });

    main.innerHTML = newMain.innerHTML;
    document.title = doc.title;

    if (!opts.isPopState) window.history.pushState({}, '', url);
    window.scrollTo(0, 0);

    scriptSrcs.forEach(function (src) {
      var script = document.createElement('script');
      script.src = src;
      document.body.appendChild(script);
    });

    // These normally only ever run once, off the real DOMContentLoaded event — a client-side
    // swap never refires that, so the incoming page's own reveal-on-scroll / scroll-focus
    // elements need an explicit re-scan. Each guarded since assets/animations.js only loads at
    // all when the "Reveal sections on scroll" theme setting is on.
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(main);
    if (typeof initializeGrowInTrigger === 'function') initializeGrowInTrigger(main);
    if (typeof initializeScrollZoomAnimationTrigger === 'function') initializeScrollZoomAnimationTrigger();
    if (typeof initializePageScrollFocus === 'function') initializePageScrollFocus();

    syncActiveNavLinks();

    main.classList.remove('is-page-transitioning');
    isTransitioning = false;
  }

  // The header's own nav links carry is-active/aria-current="page", computed server-side once
  // at render time from the request URL (see sections/custom-header.liquid) — a pushState-only
  // URL change never re-runs that Liquid, so without this the menu would keep highlighting
  // whichever page was current when the header itself was last actually rendered by the server,
  // not the page the shopper is now looking at. Scoped to exactly the two links this module
  // cares about (home/catalog), the same way everything else here is — not a generic "sync every
  // nav link's active state" utility.
  function syncActiveNavLinks() {
    var here = currentPath();
    document.querySelectorAll('a[href]').forEach(function (link) {
      var linkPath = normalizePath(link.pathname);
      if (linkPath !== homeUrl && linkPath !== catalogUrl) return;
      var isActive = linkPath === here;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }
})();
